import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import packageJson from "../../../package.json";

type ProfileOptions = {
  key: number;
  label: string;
  divider: boolean;
  icon: any;
  path?: string;
  testId?: string;
};

const ProfileOptionsLoggedIn: ProfileOptions[] = [
  {
    key: 0,
    label: "Sign out",
    divider: false,
    icon: LogoutIcon,
    testId: "user-menu-logout",
  },
  {
    key: 99,
    label: `Version: ${packageJson.version}${process.env.NODE_ENV !== "production" ? packageJson.devBuild : ""}`,
    divider: false,
    icon: BuildCircleIcon,
    testId: "user-menu-version",
  },
];

export { ProfileOptionsLoggedIn };
